"use client";

import Script from "next/script";

/**
 * Datadog RUM initialisation component.
 * Must be a "use client" component so that NEXT_PUBLIC_* env vars are read
 * at runtime (client bundle) rather than being baked in as empty strings
 * during a server-side build. The init call is guarded: if applicationId or
 * clientToken are missing, RUM is silently skipped rather than initing with
 * invalid credentials.
 */
export function DatadogRum() {
  const applicationId = process.env.NEXT_PUBLIC_DD_RUM_APPLICATION_ID ?? "";
  const clientToken = process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN ?? "";
  const site = process.env.NEXT_PUBLIC_DD_SITE ?? "";
  const service = process.env.NEXT_PUBLIC_DD_SERVICE ?? "";
  const env = process.env.NEXT_PUBLIC_DD_ENV ?? "";
  const version = process.env.NEXT_PUBLIC_DD_VERSION ?? "";

  return (
    <>
      <Script
        id="dd-rum-sync"
        src="https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js"
        type="text/javascript"
        strategy="beforeInteractive"
      />
      <Script id="datadog-rum">{`
        (function() {
          var applicationId = ${JSON.stringify(applicationId)};
          var clientToken = ${JSON.stringify(clientToken)};
          if (!applicationId || !clientToken) return;
          window.DD_RUM && window.DD_RUM.init({
            applicationId: applicationId,
            clientToken: clientToken,
            site: ${JSON.stringify(site)},
            service: ${JSON.stringify(service)},
            env: ${JSON.stringify(env)},
            version: ${JSON.stringify(version)},
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            defaultPrivacyLevel: 'allow',
          });
          if (window.DD_RUM) {
            function generateUUID() {
              // Preferred: native randomUUID (secure contexts, 2021+ browsers)
              if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
                return crypto.randomUUID();
              }
              // Fallback 1: crypto.getRandomValues (available in non-secure contexts too)
              if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
                var buf = new Uint8Array(16);
                crypto.getRandomValues(buf);
                buf[6] = (buf[6] & 0x0f) | 0x40; // version 4
                buf[8] = (buf[8] & 0x3f) | 0x80; // variant bits
                var hex = Array.from(buf).map(function(b) {
                  return ('00' + b.toString(16)).slice(-2);
                }).join('');
                return hex.slice(0,8)+'-'+hex.slice(8,12)+'-'+hex.slice(12,16)+'-'+hex.slice(16,20)+'-'+hex.slice(20);
              }
              // Fallback 2: Math.random (last resort)
              return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0;
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
              });
            }
            var STORAGE_KEY = 'sn_user_id';
            var userId = localStorage.getItem(STORAGE_KEY);
            if (!userId) {
              userId = generateUUID();
              localStorage.setItem(STORAGE_KEY, userId);
            }
            window.DD_RUM.setUser({ id: userId });
          }
        })();
      `}</Script>
    </>
  );
}
